import type { HSLColor } from "../types/colors/HSLColor"
import type { RGBColor } from "../types/colors/RGBColor"
import { Abs, Max, Min } from "../math/Math"

/**
 * Converts RGB color to HSL color
 * Assumes RGB values are in range 0-1
 */
export const RgbToHsl = ({ alpha, blue, green, red }: RGBColor): HSLColor => {
  // Find the maximum and minimum values to calculate saturation
  const max = Max(red, green, blue)
  const min = Min(red, green, blue)
  const delta = max - min

  // Calculate lightness
  const lightness = (max + min) / 2

  // Calculate saturation
  let saturation = 0
  if (delta !== 0) {
    saturation = delta / (1 - Abs(2 * lightness - 1))
  }

  // Calculate hue (0-1)
  let hue = 0
  if (delta !== 0) {
    if (max === red) {
      hue = ((green - blue) / delta) % 6
    } else if (max === green) {
      hue = (blue - red) / delta + 2
    } else {
      hue = (red - green) / delta + 4
    }

    hue /= 6 // Normalize to 0-1
    if (hue < 0) hue += 1
  }

  return { alpha, hue, lightness, saturation }
}
